import { AlertBar, Icons } from "@win-reality/react-ui";

function LiveEventLockedAlert() {
  return (
    <AlertBar
      icon={<Icons.Padlock className="size-5" />}
      variant="info"
      className="mb-4"
    >
      You are not able to change event details once it's started
    </AlertBar>
  );
}

export { LiveEventLockedAlert };
